import { fetchWrapper } from "_helpers";

const baseUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_CONTEXT_PATH}/productForecasts`;

export const productForecastService = {
  create,
  getAll,
  getForecastById,
  search
};

function create(payload) {
  return fetchWrapper.post(baseUrl, payload);
}

function getAll() {
  return fetchWrapper.get(baseUrl);
}

function getForecastById(id) {

  return fetchWrapper.get(`${baseUrl}/${id}`);
}


function search(params) {
  return fetchWrapper.get(`${baseUrl}${params}`);
}